import {Routes} from '@angular/router';
import {AuthComponent} from './pages/auth/auth.component';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {AuthLayoutComponent} from './pages/auth/auth-layout/auth-layout.component';
import {ProfileSetupComponent} from './pages/profile-setup/profile-setup.component';
import {PointsPurchaseComponent} from './pages/points-purchase/points-purchase.component';
import { LoginComponent } from './pages/auth/login.component';
import {SupportComponent} from './pages/support/support.component';
import {GamePageComponent} from './pages/game-screen/game-page.component';
import {authGuard} from './pages/auth/guards/auth.guard';
import {ProfileComponent} from './pages/profile/profile.component';
import {PrivacyPolicyComponent} from './pages/privacy-policy/privacy-policy.component';
import {TermsOfServiceComponent} from './pages/terms-of-service/terms-of-service.component';
import {AuthGuard} from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        component: AuthComponent
      },
      {
        path: 'login',
        component: LoginComponent
      },
    ]
  },
  {
    path: 'profile-setup',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        component: ProfileSetupComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  { path: 'privacy-policy', component: PrivacyPolicyComponent},
  { path: 'terms-of-service', component: TermsOfServiceComponent},
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard]
  },
  { path: 'shop', component: PointsPurchaseComponent, canActivate: [authGuard] },
  { path: 'support', component: SupportComponent, canActivate: [authGuard] },
  { path: 'game', component: GamePageComponent, canActivate: [authGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [authGuard] },
  {
    path: '**',
    redirectTo: 'dashboard',
  }
];
